export default __webpack_public_path__ + "static/media/1007.1ca3901f.svg";